import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../actions/index';
import Workday from './workday';
import ActivityModal from './activity-modal';
import HoursOfServiceModal from './hours-of-service-modal';
import CommentsModal from './comments-modal';
import NotesModal from './notes-modal';
import PayperiodModal from './payperiod-modal';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import 'react-super-responsive-table/src/SuperResponsiveTableStyle.css';
import {constants, KeolisSpinner, moment} from './common/commonExport';
import AdminCommonSection from '../components/adminLayout';

class Workdays extends React.Component {

    constructor(props) {
        super(props);
        this.currentPageNum = 1;
    }

    // get workdays when loading workdays component
    fetchWorkdays(fetchObj) {
        this.props.fetchWorkdays(fetchObj);
    }

    // handling pagination
    handlePagination(event) {
        var empId = this.props.authDetails.employeeID;
        switch (event) {
            case "first":
                this.currentPageNum = 1;
                break;
            case "prev":
                this.currentPageNum = this.currentPageNum - 1;
                break;
            case "next":
                this.currentPageNum = this.currentPageNum + 1;
                break;
            case "last":
                this.currentPageNum = this.props.pageNum;
                break;
        }
        this.fetchWorkdays(constants.actionUrls.WORKDAYS_URL, empId, this.currentPageNum);
    }

    // called before render of component
    componentWillMount() {
        let empId = this.props.impersonateUserId>0?this.props.impersonateUserId:this.props.authDetails.employeeID,
            fetchObj = {
            url:constants.actionUrls.WORKDAYS_URL,
            role: 'emp',
            empId:empId,
            source: 'web',
            pageNum:1
        }
        if (empId) {
            this.currentPageNum = 1;
            localStorage.setItem('empId', empId);
            localStorage.setItem('route', constants.PAYDETAILS);
            this.fetchWorkdays(fetchObj);
        }
    }

    // rendering different modals as needed
    renderModal() {
  
        if(this.props.notesObj.notesObj && this.props.notesObj.notesObj.showNotesModal){
            var modalStatus = this.props.notesObj.notesObj.showNotesModal;
            var modalName = this.props.notesObj.notesObj.modalName;
        } else {
            var modalStatus = this.props.showModal;
            var modalName = this.props.modalName;
        }
        if (modalStatus && modalName == "notes_Modal") {
            return (<NotesModal/>)
        } else if (modalStatus && modalName == constants.hosModals.Certify_Modal) {
            return (<ActivityModal isLogUser = {false}  islogAdmin = {this.props.authDetails.impersonateUserId>0} isPayDetail={true}/>)
        } else if (modalStatus && modalName == constants.hosModals.Certified_Modal) {
            return (<HoursOfServiceModal workdays={this.props.workdays} />)
        } else if (modalStatus && modalName == constants.hosModals.Comments_Modal) {
          
            return (<CommentsModal isLogUser = {false} />)
        } else if (modalStatus && modalName == constants.hosModals.payperiod_modal) {
            return (<PayperiodModal />)
        }
    }

    // render workdays
    renderWorkdays() {
        var workdays = this.props.workdays, role = this.props.authDetails.role;
        if (workdays && workdays.length > 0) {
            return (
                workdays.map(function (workday, index) {
                    return (<Workday workday={workday} key={workday.id + workday.wdy_date} role={role} />);
                })
            )
        }
        else if (this.props.hasErrored) {
            return <div>Sorry some Error...</div>;
        } else if (this.props.isLoading) {
            return (
                <tr>
                    <td>
                        <KeolisSpinner />
                    </td>
                </tr>
            )
        } else {
            return (
                <tr>
                    <td colSpan="100%">
                        No Records Available
                    </td>
                </tr>
            )
        }
    }

    // rendering pagination component
    renderPagination() {
        return (
            <div id="pageNumber">
                {
                    this.currentPageNum == 1 ?
                        <button className="btn btn-default firstPage disabled">❮❮</button>
                        : <button className="btn btn-default firstPage" onClick={() => this.handlePagination("first")}>❮❮</button>
                }
                {
                    this.currentPageNum == 1 ?
                        <button className="btn btn-default prevPage disabled">❮</button>
                        : <button className="btn btn-default prevPage" onClick={() => this.handlePagination("prev")}>❮</button>
                }
                {
                    (this.currentPageNum == this.props.pageNum) ?
                        <button className="btn btn-default nextPage disabled">❯</button>
                        : <button className="btn btn-default nextPage" onClick={() => this.handlePagination('next')}>❯</button>
                }
                {
                    (this.currentPageNum == this.props.pageNum) ?
                        <button className="btn btn-default lastPage disabled">❯❯</button>
                        : <button className="btn btn-default lastPage" onClick={() => this.handlePagination('last')}>❯❯</button>
                }
            </div>
        )
    }
    showModal(modalName){
        this.props.onShowModal(modalName);
    }

    onRefresh(){
        let workday_date = Array.isArray(this.props.workdays) && this.props.workdays.length > 0 ? this.props.workdays[0].wdy_date : '';
        let workday_date_formated = workday_date ? moment(workday_date, 'MM/DD/YYYY').format('YYYYMMDD') : '';
        let empId = this.props.authDetails.impersonateUserId>0?this.props.authDetails.impersonateUserId:this.props.authDetails.employeeID,
        fetchObj = {
            url:constants.actionUrls.WORKDAYS_URL,
            role: 'emp',
            empId:empId,
            source: 'web',
            pageNum:1,
            workdayDate: workday_date_formated,
            pay_certify_status: this.props.workdays.length > 0 ?  this.props.workdays[0].wdy_certify_status : '',
            isRefresh : true
        }
        this.fetchWorkdays(fetchObj);
    }
    render() {
        const { printStatus } = this.props.printState;
        const refreshed_time = Array.isArray(this.props.workdays) && this.props.workdays.length > 0 && this.props.workdays[0].refreshed_time ? this.props.workdays[0].refreshed_time : '';
        const isMenumappingConf = this.props.authDetails.activeMenus && Array.isArray(this.props.authDetails.activeMenus) && this.props.authDetails.activeMenus.length > 0 ;
        const parialClassname = isMenumappingConf ? "text-center hidden" : "text-center";
        let compTitle = "My Hours of Service"
        return (
            <AdminCommonSection compTitle={compTitle} refreshTime={refreshed_time} admin={false} onRefresh={this.onRefresh.bind(this)}
                tblBody={
                    <div>
                        <div id="tblMainActivities" className={"employeeTbl " + (this.props.authDetails.role != constants.roles.ADMIN_ROLE ? 'spaceFromBottom' : '')} >
                            <Table className="table table-striped table-bordered_header table-condensed">
                                <Thead className="thead-default">
                                    <Tr>
                                        <Th>Notes</Th>
                                        <Th>Date</Th>
                                        <Th className="text-center">Job Symbol</Th>                                        
                                        
                                        <Th className={parialClassname}>Job Type</Th>
                                        <Th className={parialClassname}><span title="Time off prior to starting your shift">Time Off Prior</span></Th>
                                        <Th className={parialClassname}><span title="Total hours of service">Total HOS</span></Th>
                                        
                                        <Th className="text-center"><span title="Total hours of shift">Total Shift</span></Th>
                                        <Th className="text-center">Certified</Th>
                                    </Tr>
                                </Thead>
                                <Tbody>
                                {
                                    this.renderWorkdays()
                                }
                                </Tbody>
                            </Table>
                            {
                                this.renderModal()
                            }
                        </div>
                </div>
                }
            />
        );
    }
}

function mapStateToProps(state) { // coming from store
    return {
        workdays: state.workdays.workdays,
        pageNum: state.workdays.pageNum,
        hasErrored: state.workdays.itemsHasErrored,
        isLoading: state.workdays.isLoading,
        showModal: state.modals.showModal,
        modalName: state.modals.modalName,
        workday: state.workday.workday,
        activities: state.workdays.activities,
        authDetails: state.authState,
        printState:state.printState,
        notesObj:state.notes
        
    };
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            onShowModal: actions.showModalAction,
            fetchWorkdays: actions.fetchWorkdays,
            notify:actions.notifyAction
        }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(Workdays);